import { DtoBase } from "../DtoBase";
import { List } from "../../DiscoveryEngine.TS/Utils/List";
import { ObjSerUtils } from "../../DiscoveryEngine.TS/Serialization/ObjSerUtils";
import { ValueEncoder } from "DiscoveryEngine.TS/Utils";


export class NetworkTransferResultDto extends DtoBase {

	public Succeeded: boolean;
	public Errors: List<string>;

	constructor() {
		super();

		this.Clear();
	}

	public Clear(): void {
		this.Succeeded = false;
		this.Errors = new List<string>();
	}

	public get HasErrors(): boolean {
		return (!!this.Errors && this.Errors.Count > 0);
	}

	public Write(obj: any, context: any): void {
		obj.network_transfer_result = {};
		obj = obj.network_transfer_result;

		super.Write(obj, context);

		obj.succeeded = ValueEncoder.EncodeBoolean(this.Succeeded);

		if (this.HasErrors) {
			obj.errors = [];
			ObjSerUtils.WriteStringValueCollection(obj.errors, this.Errors, context);
		}
	}

	public Read(obj: any, context: any): void {
		if (!obj.network_transfer_result)
			throw new Error();
		obj = obj.network_transfer_result;

		super.Read(obj, context);

		if (obj.succeeded !== undefined) {
			this.Succeeded = ValueEncoder.DecodeBoolean(obj.succeeded);
		}

		if (obj.errors !== undefined) {
			this.Errors.Clear();
			ObjSerUtils.ReadStringValueCollection(obj.errors, this.Errors, context);
		}
	}

}
